module.exports = __webpack_public_path__ + "static/media/cchub.71213d45.png";